export default __webpack_public_path__ + "static/media/sass-thumb-3.a902bf18.png";